<template>
  <div>
    <v-toolbar dense color="highlight" dark flat class="sticky">
      <v-toolbar-title>{{$t('todosForInstallers')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
      <div class="wrapper">
        <v-card tile class="box" v-for="(item,i) in items" :key="i">
          <v-card-title>{{item.installer}}</v-card-title>
          <div
            ref="todo"
            class="content"
            :class="isOverFlow(item,i)  ? 'content' : item.active ? 'content_active': ''"
          >
            <v-list>
              <v-list-item v-for="(t,i) in item.todos" :key="i">
                <v-list-item-content>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div @click="blueprintDetails(t)" v-bind="attrs" v-on="on" v-text="t.breadCrumb"></div>
                      <div v-if="t.deadline"><small>{{$t('deadline')}}: {{t.deadline}}</small></div>
                    </template>
                    <span>{{t.breadCrumb}}</span>
                  </v-tooltip>
                  <!-- <v-list-item-subtitle v-text="t.breadCrumb"></v-list-item-subtitle> -->
                </v-list-item-content>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-icon v-on="on" v-bind="attrs">
                      <v-badge color="primary" :content="t.count"></v-badge>
                    </v-list-item-icon>
                  </template>
                  <span>{{t.count}} {{$t('todos')}}</span>
                </v-tooltip>

                <!-- <v-icon :color="item.active ? 'deep-purple accent-4' : 'grey'">chat_bubble</v-icon> -->
              </v-list-item>
            </v-list>
          </div>
          <!-- </div> -->
          <div
            @click="collapse(item)"
            v-if="item.isOverflowing"
            :class="item.active ? 'active': ''"
            class="collapsible d-flex justify-center"
          >
            <v-icon color="primary">{{item.active ? 'fa-chevron-up': 'fa-chevron-down'}}</v-icon>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>


<script>
import jwtdecode from "jwt-decode";
import dataTable from "@/components/Datatable";
export default {
  name: "Todo",
  components: {
    dataTable
  },
  data() {
    return {
      items: [],
      // reports: [],
      progress: true,
      response: false,
      dialog: false,
      readonlyblueprint: null
    };
  },

  methods: {
    isOverFlow(todo, i) {
      this.$nextTick(() => {
        if (this.$refs.todo) {
          if (todo.isOverflowing === undefined) {
            var elements = this.$refs.todo;
            let el = elements[i];
            var curOverflow = el.style.overflow;
            if (!curOverflow || curOverflow === "visible")
              el.style.overflow = "hidden";
            var isOverflowing =
              el.clientWidth < el.scrollWidth ||
              el.clientHeight < el.scrollHeight;

            el.style.overflow = curOverflow;

            if (isOverflowing) todo.isOverflowing = true;
            else todo.isOverflowing = false;
            if (!isOverflowing) el.classList.remove("content");
            this.$forceUpdate();
          }
        } else {
          todo.isOverflowing = false;
        }
        return todo.isOverflowing;
      });
    },
    collapse(document) {
      document.active = !document.active;
      this.$forceUpdate();
    },
    blueprintDetails(item) {
      //will be redirected anyways to readonly if not allowed
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: { id: item.id }
      });
    },
  },
  created() {
    this.$http
      .getTodosGroupedByInstaller()
      .then(res => {
        this.items = res.data;
        this.progress = false;
      })
      .catch(err => {
        this.progress = false;
        console.log(err);
      });
    this.$store.state.previous = null;
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  --auto-grid-min-size: 20rem;
  display: grid;
  grid-gap: 1em;
  grid-template-columns: repeat(
    auto-fit,
    minmax(var(--auto-grid-min-size), 1fr)
  );
}

.box {
  border-radius: 5px;
  padding: 1em;
  height: auto;
}

.collapsible {
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
}

.content {
  padding: 0 18px;
  max-height: 100px;
  overflow: hidden;
  transition: max-height 0.2s ease-in-out;
  // background-color: #f1f1f1;
}
.content_active {
  max-height: 10000px;
  transition: max-height 0.2s ease-in-out;
  background-color: unset;
}
</style>


// WEBPACK FOOTER //
// src/views/todo/InstallersTodos.vue